<template>
  <div class="main-content">
    <!-- Title -->
    <div>
      <b-row class="mb-16">
        <b-col md="8">
          <h2 class="page-title">
            Resource Sheet Report
          </h2>
        </b-col>
      </b-row>
    </div>
    <!-- Filters -->
    <template>
      <b-row>
        <b-col md="2">
          <b-button
            pill
            class="clear-btn m-lg-2"
            size="sm"
            @click="getExcelReport(0)"
            >Export This & Week After</b-button
          >
        </b-col>
        <b-col md="2">
          <b-button
            pill
            class="clear-btn m-lg-2"
            size="sm"
            @click="getExcelReport(1)"
            >Export Next & Week After Next Week</b-button
          >
        </b-col>
      </b-row>
      <b-card title="Report Filters" class="mt-2">
        <b-row class="mt-1">
          <b-col md="6" class="checkbox">
            <b-form-group>
              <b-form-checkbox v-model="excludeUnassigned"
                >Exclude Unassigned</b-form-checkbox
              >
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <div>
              <b-form-group label="Users" label-for="tags-component-select">
                <!-- Prop `add-on-change` is needed to enable adding tags vie the `change` event -->
                <b-form-tags
                  id="tags-component-select"
                  v-model="userValue"
                  size="lg"
                  class="mb-2"
                  add-on-change
                  no-outer-focus
                >
                  <template
                    v-slot="{
                      tags,
                      inputAttrs,
                      inputHandlers,
                      disabled,
                      removeTag
                    }"
                  >
                    <b-form-select
                      v-bind="inputAttrs"
                      :options="userAvailableOptions"
                      :disabled="disabled || userAvailableOptions.length === 0"
                      v-on="inputHandlers"
                    >
                      <template #first>
                        <!-- This is required to prevent bugs with Safari -->
                        <option disabled value="">Select a user...</option>
                      </template>
                    </b-form-select>
                    <ul
                      v-if="tags.length > 0"
                      class="list-inline d-inline-block mb-2 mt-2"
                    >
                      <li
                        v-for="tag in tags"
                        :key="tag"
                        class="list-inline-item"
                      >
                        <b-form-tag
                          :title="tag"
                          :disabled="disabled"
                          variant="info"
                          class="mt-1"
                          @remove="removeTag(tag)"
                          >{{ tag }}</b-form-tag
                        >
                      </li>
                    </ul>
                  </template>
                </b-form-tags>
              </b-form-group>
            </div>
          </b-col>
          <b-col md="6">
            <div>
              <b-form-group
                label="Excluded Statuses"
                label-for="tags-component-select"
              >
                <!-- Prop `add-on-change` is needed to enable adding tags vie the `change` event -->
                <b-form-tags
                  id="tags-component-select"
                  v-model="statusValue"
                  size="lg"
                  class="mb-2"
                  add-on-change
                  no-outer-focus
                >
                  <template
                    v-slot="{
                      tags,
                      inputAttrs,
                      inputHandlers,
                      disabled,
                      removeTag
                    }"
                  >
                    <b-form-select
                      v-bind="inputAttrs"
                      :options="statusAvailableOptions"
                      :disabled="
                        disabled || statusAvailableOptions.length === 0
                      "
                      v-on="inputHandlers"
                    >
                      <template #first>
                        <!-- This is required to prevent bugs with Safari -->
                        <option disabled value="">Select a status...</option>
                      </template>
                    </b-form-select>
                    <ul
                      v-if="tags.length > 0"
                      class="list-inline d-inline-block mb-2 mt-2"
                    >
                      <li
                        v-for="tag in tags"
                        :key="tag"
                        class="list-inline-item"
                      >
                        <b-form-tag
                          :title="tag"
                          :disabled="disabled"
                          variant="info"
                          class="mt-1"
                          @remove="removeTag(tag)"
                          >{{ tag }}</b-form-tag
                        >
                      </li>
                    </ul>
                  </template>
                </b-form-tags>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex"

export default {
  layout: "default",
  name: "ResourceSheetReport",
  components: {},
  data() {
    return {
      loading: true,
      state: "All",
      userNames: [],
      userSearch: "",
      userValue: [],
      statusValue: [],
      excludeUnassigned: false
    }
  },
  apollo: {
    users: {
      query: require("@/graphql/Account/GetUsersLW.gql"),
      fetchPolicy: "no-cache",
      update: data =>
        data.users
          ?.sort((a, b) => (a?.firstName > b?.firstName ? 1 : -1))
          .map(function(item) {
            return item["firstName"] + " " + item["lastName"].trim()
          })
          ?.filter(x => x.trim() != "**Unassigned**")
    }
  },
  computed: {
    ...mapState({
      statuses: state => state.statuses.all
    }),
    resourceSheetReportApiLink() {
      return process.env.VUE_APP_FILE_GET_RESOURCESHEET_REPORT_HTTPS
    },
    userAvailableOptions() {
      return (
        this.users?.filter(opt => this.userValue?.indexOf(opt) === -1) ??
        this.userNames
      )
    },
    statusAvailableOptions() {
      return (
        this.statuses
          ?.map(function(item) {
            return item["value"]
          })
          .filter(opt => this.statusValue?.indexOf(opt) === -1) ?? []
      )
    }
  },
  methods: {
    getExcelReport(week) {
      window.location.href = `${
        this.resourceSheetReportApiLink
      }?week=${week}&usersIncluded=${this.userValue.join()}&statusExcluded=${this.statusValue.join()}&isExcludeUnassigned=${
        this.excludeUnassigned
      }`
    },
    getUserNames() {
      return this.users.map(function(item) {
        return item["firstName"] + " " + item["lastName"]
      })
    }
  }
}
</script>

<style scoped>
.badge-info {
  background-color: #3f51b5;
}

.close {
  color: #fff !important;
  text-shadow: 0 1px 0 #bdbcbc !important;
  opacity: 0.8 !important;
}
.form-control {
  background: transparent;
  border: 0px solid #ffffff00;
}
</style>
